import {createResetAllAction} from '@di-nxt/resource-container';
import {Dispatch} from 'redux';
import {EnhancedErrorHandler} from '../types';
import {getHttpStatusCode} from './getHttpStatusCode';

export const onAuthErrorLogout: EnhancedErrorHandler = (
  error: Error,
  dispatch: Dispatch,
) => {
  const httpStatus = getHttpStatusCode(error);

  console.log('onAuthErrorLogout:', httpStatus);

  if ([401, 403].includes(httpStatus ?? 0)) {
    console.log('onAuthErrorLogout: resetAll');

    dispatch(createResetAllAction());

    return undefined;
  }

  return error;
};
